import type { CSSProperties } from 'react';

import { isDefined } from '@enterprise/core';

import type { LoadingProps } from './types/loading.props';

/**
 * Renders a glowing loading indicator with an optional message and configurable size.
 *
 * @internal
 * @param props - The loading component props.
 * @param props.message - Optional message to display alongside the loader.
 * @param props.size - Optional size multiplier for the loader. Defaults to 1.
 * @returns The Glow loading indicator component.
 */
export const Glow = ({ message, size }: LoadingProps) => {
  return (
    <div
      className="loader-glow"
      style={{ '--multiplier': isDefined(size) ? size : undefined } as CSSProperties}>
      <div>{message}</div>
      <div className="circle" />
    </div>
  );
};
